import { Box } from "@mui/material";
import discoMockup from "../../assets/mock-ups/disco.png";

export function DiscoJobContent() {
  return (
    <Box
      display="flex"
      justifyContent="center"
      pt={{ xs: 4, md: 8 }}
      width="100%"
    >
      <Box
        component="img"
        src={discoMockup}
        alt="Disco app mockup"
        sx={{
          borderRadius: 0,
          height: { xs: "280px", sm: "350px", md: "450px" },
          objectFit: "contain",
          userSelect: "none",
          pointerEvents: "none",
        }}
        draggable={false}
      />
    </Box>
  );
}
